<script lang="ts" setup>
    import { EntrepriseModel } from "~/model"

    defineProps({
        entreprise: {
            type: EntrepriseModel,
            required: true,
        },
    })
</script>

<template>
    <div class="mt-2">
        <v-chip label size="small" variant="outlined">
            Webservice
            {{ entreprise?.WEBSERVICE_SERVER?.name }}
            ({{ entreprise?.WEBSERVICE_SERVER?.description }})
        </v-chip>
    </div>
</template>
